module.exports = __webpack_public_path__ + "img/bg.ec6b7b1c.jpg";